import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { NomDateTimeFormats } from 'src/app/core/constants';
import { getNestedProperty } from 'src/app/shared/utils/object-utils';
import {
  EMPTY_VALUE_PLACEHOLDER,
  isEmptyTimestamp,
} from '@sensika/ag-grid-kit';

@Component({
  selector: 'app-ag-date-cell-renderer',
  templateUrl: './ag-date-cell-renderer.component.html',
  styleUrls: ['./ag-date-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AgDateCellRendererComponent implements ICellRendererAngularComp {
  params: any;
  date: any;

  agInit(params: any): void {
    this.date = this.readDate(params);
  }

  refresh(params: any): boolean {
    this.date = this.readDate(params);

    return true;
  }

  /** The cell's date, or null for an unset timestamp (incl. the 1970 epoch). */
  private readDate(params: any): unknown {
    const raw = getNestedProperty(params, 'data.' + params.colDef?.field, '');
    return isEmptyTimestamp(raw) ? null : raw;
  }

  protected readonly placeholder = EMPTY_VALUE_PLACEHOLDER;

  protected readonly NomDateTimeFormats = NomDateTimeFormats;
}
